module.exports = __webpack_public_path__ + "static/assets/e9633276fec172efb213b0e171b27787.png";